import React from "react";

const ProjetImg = ({ image }) => {
  return (
    <div className="projetImg marginApp">
      <img src={image} alt=""></img>
    </div>
  );
};

export default ProjetImg;
